import React, { createContext, useState, useEffect } from 'react';

// Crear el contexto del chatbot
export const ChatbotContext = createContext();

// Proveedor del contexto
export const ChatbotProvider = ({ children }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detectar si el usuario está en un móvil
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768); // Ajusta el tamaño según sea necesario
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // Función para alternar el estado del chatbot
  const toggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  return (
    <ChatbotContext.Provider value={{ isChatOpen, toggleChat, isMobile }}>
      {children}
    </ChatbotContext.Provider>
  );
};
